/**
 * @file index.js
 * @author sunxiaofeng01
 * @desc 商品购买
 */

import bendsdk from '@baidu/bend-plugin-sdk';
const routes = [
    {
        path: '/goodsPurchase',
        name: 'goodsPurchase',
        meta: {auth: 'in'},
        component: () => import('./views/index')
    },
    {
        path: '/goodsPurchase/success',
        name: 'clueSuccess',
        meta: {auth: 'in'},
        component: () => import('./views/success')
    },
    {
        path: '/goodsPurchase/fail',
        name: 'clueFail',
        meta: {auth: 'in'},
        component: () => import('./views/fail')
    }
];

// 如果有权限控制的话，这里得引入SDK判断权限是否可以调用本插件，或者重插件配置页面读取插件信息
export default class orderManage extends bendsdk.plugin {
    onInstall(router) {
        Array.prototype.push.apply(router.options.routes, routes);
        router.addRoutes(routes);
    }
}
